
// Define a properly typed cache
interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

// Only define entriesCache once and export it
export const entriesCache: Record<string, CacheEntry<any>> = {};
const CACHE_TTL = 60000; // 1 minute cache TTL
const pendingSaves: Record<string, Promise<void>> = {};

export const clearCacheForKey = (key: string) => {
  Object.keys(entriesCache).forEach(cacheKey => {
    if (cacheKey.includes(key)) {
      delete entriesCache[cacheKey];
    }
  });
};

export const clearTrendCache = (type: string) => {
  Object.keys(entriesCache).forEach(key => {
    if (key.includes('trend') && key.includes(type)) {
      delete entriesCache[key];
    }
  });
};

export const getCachedData = <T>(cacheKey: string): T | null => {
  const cachedData = entriesCache[cacheKey];
  if (cachedData && (Date.now() - cachedData.timestamp < CACHE_TTL)) {
    return cachedData.data as T;
  }
  return null;
};

export const setCachedData = <T>(cacheKey: string, data: T, ttlInSeconds?: number) => {
  entriesCache[cacheKey] = {
    data,
    timestamp: Date.now()
  };
};

export const getPendingSave = (saveId: string) => pendingSaves[saveId];
export const setPendingSave = (saveId: string, promise: Promise<void>) => {
  pendingSaves[saveId] = promise;
};
export const deletePendingSave = (saveId: string) => {
  delete pendingSaves[saveId];
};
